// 環境判斷函數
const getBaseConfig = () => {
   const host = window.location.hostname; // ✅ 正确：获取并存储到变量 `host`
  const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const isInternalIP = /^10\.|^192\.168\.|^172\.(1[6-9]|2[0-9]|3[0-1])\./.test(host); // 匹配私有IP段
  const isDevelopment = window.location.hostname.includes('.local') || process.env.NODE_ENV === 'development'; // 可結合構建環境變數

  if (isLocal  || isInternalIP|| isDevelopment) {//|| isInternalIP
    // 使用当前页面的协议、主机和端口动态构建地址
    const currentOrigin = window.location.origin; // 例如: https://10.147.77.177:8081
    return {      
      appBaseUrl: currentOrigin // 對應您文檔中可能出現的本地端口 'https://localhost:8081'
    };

    // 开发环境
    // return {
    //   appBaseUrl: window.location.origin, // 例如: http://localhost:8080
    //   authority: "https://login.microsoftonline.com/organizations", // 开发环境使用通用租户
    //   resource: "https://diaidentityservice.azurewebsites.net" // 您的 API 资源
    // };

  } else {
    // 生產環境或指定網址環境
    return {      
      //appBaseUrl: 'https://spturbosolution.azurewebsites.net' // 對應文檔中提供的第三個鏈接
      appBaseUrl: 'https://diasolutioncentercn.deltaww.com' 
    };

    // 生产环境
    // return {
    //   appBaseUrl: "https://spturbosolution.azurewebsites.net", // 您的生产环境域名
    //   authority: "https://login.microsoftonline.com/e22f3d72-e156-44d8-a8b9-07c4cc0b3d87", // 您的租户 ID
    //   resource: "https://diaidentityservice.azurewebsites.net" // 您的 API 资源
    // };
  }
};

const baseConfig = getBaseConfig();

// 導出的配置物件

export const authConfig = {
  authority: `https://deltaiastudio.b2clogin.com/deltaiastudio.onmicrosoft.com`,
  client_id: "05ca241c-1466-4033-b8c2-2782189fb22a",  
  redirect_uri: baseConfig.appBaseUrl,//encodeURIComponent(baseConfig.appBaseUrl),//上傳時須修改為以下位置:https://spturbosolution.azurewebsites.net/
  response_type: "id_token",
  scope: encodeURIComponent("openid"),
  response_mode: "fragment",
  // resource:"https://diaidentityservice.azurewebsites.net",

  //登出
  post_logout_redirect_uri:baseConfig.appBaseUrl ,// encodeURIComponent(baseConfig.appBaseUrl),//上傳時須修改為以下位置:https://spturbosolution.azurewebsites.net/ 
  // 新增 MSAL 相关配置
  msal: {
    auth: {
      clientId: "5b8adb3f-3c9d-41a5-bb10-1982ebc20d11",
      authority: baseConfig.authority,
      redirectUri: `${baseConfig.appBaseUrl}/redirect`,
      postLogoutRedirectUri: baseConfig.appBaseUrl
    },
    cache: {
      cacheLocation: "sessionStorage"
    }
  }
};

export const apiAuthConfig = {
  grant_type:"client_credentials",
  client_id: "5b8adb3f-3c9d-41a5-bb10-1982ebc20d11",  
  clientSecret:"FDjLG6W621QHZl+CS8Vlxav6CQ2Kig0Gvs5ngr6KgqA=",  
  resource:"https://diaidentityservice.azurewebsites.net",
};
